<template>
  <div id="wenwucaishenbaoku">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>文武财神寶库</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">文武财神寶库</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="
                    require('@/assets/img/products/wen-wu-cai-shen-bao-ku.jpg')
                  "
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『文武财神寶库』</h5>

                <p class="project-description">
                  在中国,
                  掌管财富的神衹不止一位，所以被尊为财神的也不止一位。神通最大,
                  牌子最硬, 名份最正的财神-赵公元帅。
                  赵公元帅本名赵朗，字公明，早年品行不端，恶名昭彰。不过后来改邪归正，追随张天师在终南山修炼，得道之后被封做“玄坛元帅”。
                  袍的造型非常威武，面皮深眼大鬚浓，一手拿金轮，一手拿铁索，座下骑的是一头黑虎，本来专司捉鬼收妖。这位捉鬼的大元帅，所以会摇身一变，成为家喻户晓的财神，方面因为身具特殊的能耐，一方面也
                  因为有得力的下属。《三教搜神大全》中说袍“至如讼冤伸抑，公能使之解释；公平买卖求财，公能使之获利和合。但有公平之事，可以对神祷，无不如意"
                  。商人从事买卖，目的原在将本求利；营业中又难免受到欺压，希望能有人出来主持公道。这两件事正好都是赵公元帅的专长，当然就被商人看作祝祷的对象，希望得到袍的福祜。
                </p>

                <p class="project-description">
                  <span><b>五路财神团队力量大</b></span>
                  赵财神的能耐不仅如此，袍还有得力的助手。
                  照《封神榜》的说法，姜太公子牙在大封诸神的时候，派给赵公元帅四员大将：
                  「招财使者」陈九公，「招宝天尊」萧升，「纳珍天尊」曹宝
                  「利市仙官」姚少司。只要看这四位的官衔：招财、招宝、纳珍、利市，真是想要不当财神也难。
                  诸位也许听说过'五路财神'（请注意，'五路财神'和'五路神'
                  虽然只有一字之差，代表的神却完全不同），就是指赵公元帅和袍属下的这四位大将了。赵公元帅坐镇当中，四位大将各主东西南北之一路。这五位财神能招四路之财，进八方之宝，因此成为最有力的'财神团队'。
                  值得注意的是，从捉鬼收妖变成领军财神部队的赵公元帅，在造型上也有所改变：手衤里的金轮变成了银鞭，铁索变成了元宝。据说在拜财神的时候，如果能摸摸袍手上的元宝，财运就会特别好。
                  义薄云天，被许多行业当作守护神的武财神一．．．．一武圣关公。
                  面如重枣，美髯当胸，跨下赤兔马，手提青龙偃月刀的武圣关公，大概是中国诸多神祗中知名度最高的一位。各行各业拜关公的人越来越多，关老爷俨然成为社会中平民大众的保
                  如果您也想拜关公作自己的守护财神，要记得一定要请神像的面朝户外。尤其做生意开店的朋友，最好能请关老爷守住大门，意思是把一切邪魔与煞气挡住门外，以保祜店内生意平安无事，财源顺畅。
                  假如不懂规矩，把关老爷顷请得面朝店衤里面放的话，虽然袍老人家智勇双全
                  ，也要等邪煞进店以后才能清除。渊战之余，难免要伤及店中的生意，甚至店主的运气。这就像把恶人放进家衤里来决战一样，虽然有武林高手在一旁助拳，屋衤里的家俐和装潢都免不了要受到波及，有损毁之虞。
                  温文儒雅，在民间彩画上曝光率最高的文财神一．．．．．一财帛星君。
                  在民俗年画上最常见到的财神，不是赵公元帅，也不是武圣关公，而是一位官帽朝靴，身穿红袍，腰繫玉带，左手执玉如意，右手捧聚宝盆的温文君子。这就是文财神一一财帛星君。
                  财帛星君是北斗七星之一，专管人间财富。袍和福、禄、寿三星加上喜星在一起，就是我们常说的'五福临门，的五福。五位神仙在一起，把人间的幸福都估全了，当然最受老百姓的欢迎。
                </p>

                <p class="project-description">
                  <span><b>文财神不止一位</b></span>
                  民间传说的文财神其实不止一位。
                  像被商纣王挖掉心的忠臣比干，富可敌国，曾经是'西施眼中的情人
                  的范蠡；拥有过聚宝盆的沈万一有散财童子之称的刘海蟾。他们都曾经被人当作文财神来供奉。
                  不过比较起来，还是财帛星君的信徒最多，涵盖面最大。
                  都是财神，文管什麽？武管什麽？有人认为武财神专门保祜做生意的人，文财神只保祜朝九晚五的薪水阶级：也有人认为，需要比拼力气的行业归武财神管，需要比斗智慧的行业则归文财神统领。这些说法其实都有斟酌的馀地。
                  举例来说，香港有一座香火鼎盛的'倦爷爷庙，，据说极灵验，当地渔人出海之前必来拜祭。这座庙衤里供奉了两尊神位：一位是「护国庇民水倦爷爷之神位」，另一位是「都天至富财帛星岩之神位」。渔民既不领薪水，打鱼的工作也谈不上是全靠斗智，一样拜文财神每财帛星君。
                  那麽，究竟什麽性质的店家该拜祭文财神？什麽样的行业该供奉武财神呢？可以从行业本身的複杂性和危险性来分辨，也可以参考流年飞星，看看是不是有煞气临门来做决定。从行业来看，如果顾客的成份複杂，容易引起纠纷（如三温暖，酒廊，理疗院），或者工作的性质有可能遇到危险，最好供奉武财神。如此一来，在招财纳喜的同时，还能够有消灾解厄的效果。像香港的警察，就拜武财神关公。
                  假如没有安全上的顾虑，可以考虑拜祭文财神。（譬如上述香港的渔民，因为已经有水倦爷爷保祜他们的平安，所以就只拜文财神，而不拜武财神。
                  另外，流年飞星如果有煞星临门，表示当年容易发生灾厄意外，或者多是非小人，就有必要请关老爷当门而立，以求进财的时候也能避灾免祸。
                </p>

                <p class="project-description">
                  <span><b>拜文武财神，规矩不同</b></span>
                  前面谈到如果供奉武财神，神像必需要面朝外，好挡住妖邪煞气。但是供奉文财神却大不相同，不但要面向店内，而且最好还能放在比较隐密的地方，不要让人家都看到。
                  这是因为文财神是布施财帛的，需要面向店内，才能把财气带到店裎来。假如面向店外，会把原来属于店衤里的财气，全都布施到店外去。拜了半天，钱全都进了别人的口袋，虽然也算是做了公益事业，到底不是店家的本意。
                  那麽请财神向内，放在店中最引人注目的地方，让所有进来的客人都同沾财喜之气，大家一起发财如何？这种想要普渡众生的想法虽然无私，造成的结果却未必理想；因为店裎的财气被大家分光了，就算生意再好，结算下来也会少有盈馀。
                </p>

                <p class="project-description">
                  <span><b>土地公是兼职的财神 </b></span>
                  除了文武财神之外，掌管一方土地的土地神，也常常兼职做商家的财神。
                  土地神在神仙界官阶虽小，倒是有一个非常堂皇的官名，叫做'福德正神，。不过老百姓多半亲切的尊称袍一声'福德伯，，这个正式的官名倒是少有人用。
                  拜土地神和拜文武财神的规矩又不相同：
                  文武财神的神位要放得高。土地神却不一样，因为主管的就是土地，所以一定要把袍的神位请在地上，绝对不能架空。如果把土地的神位垫高了放，土地神是不会到位的。（不过有些住在岛屿或海边的人，为了怕涨潮淹水，自己住的房子是架高了的，所以也把土地庙高架起来，这是一种
                  同理心，倒也无可厚非。）
                  一般神位的旁边都力求洁氵爭整齐；假如乱堆杂物，要算亵渎神明，是大忌讳。但是供奉土地神的忌讳就比较少，譬如说有人把土地神的神柜放在大门口鞋柜旁边，虽然进出的人客杂沓而过，袍老人家也不以为己以忌。
                </p>

                <p class="project-description">
                  <span><b>远来的财神是不是比较能招财？</b></span>
                  以上谈到的正财神，文武财神，土地神，都是我们自己本乡本土的老牌财神。最近几十年还又多了许多'
                  舶来神'，随着佛教藏密的流传而进入我国。
                  藏密的财神中第一位名为'财宝天王，，属下统领了八骏财神，统司八方天库，据说力量非常强大。
                  另外又有'五姓财神，，因为各自具不同的颜色（绿、白、红、黄、黑），所以又称做'五色财神，。还有'
                  财源天母，，能为凡人带来财富珍宝，所以备受尊崇。更有象头财神，和非佛教的印度神礻氏渊源很深。
                  远来的和尚会念经，那麽这些远来的财神，是不是在招财方面也更加神通广大呢？到目前为止，好像还没有人做过比较。不过这些藏密财神的起源，主要是为藏密的信徒施法，希望能帮助徒众生活无虑，可以安心向佛。袍们是不是愿意为非藏密信徒的人招财？值得深思。
                </p>

                <p class="project-description">
                  <span><b>宁可信其有</b></span>
                  也基于此，諸葛孔明有限公司才会推出文武财神库，因为这种文武财神库，袍含盖了全宇宙全部的财神爷，焚化文武财神库，就等于供奉宇宙间所有的财神，也就能得天地间各路财神的庇祜。
                  二十一世纪的今天谈财神，谈供奉财 24
                  神，好像有些'开科学倒车，。不过以我多年看商业风水的经验，拜神的商家一般来说生意都比较稳定；就算碰到经济不景气的时候，损伤也比较轻微，多能有惊无险，渡过难关。
                  无论是真有神明护祜，或者只是店东自己的心理作用，只要能增加营业额，让生意获得更多的盈馀，店家们倒也不妨宁可信其有，抱着'心诚则灵，的心态，应该肯定有益无害。
                </p>

                <p class="project-description">
                  <span><b>文武财神宝库</b></span>
                  《文武财神寶库》即文财神陶朱公，武财神趙公明，受供奉的财神聖品。人们除了大年初一接财神祭祀之外，在平時的初一與十五，或感覺财運不顺(一般上是個人前世的陰間财庫不足，也有因用财逐渐散盡以及财源匮乏所致)，收賬欠奉，做生意又難週轉，無法突破瓶颈時，《文武财神寶库》焚化後，具有稳定個人财库或補充個人财库的庇祐作用。
                </p>

                <p class="project-description">
                  <span><b>《使用方法》</b></span>
                  每逢初一、十五，或平时感觉财运不顺，收账难遂之际，即可在祭祀时，当天焚化《文武财神宝库》，数量不拘
                  ， 心诚则灵。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="wen-wu-cai-shen-bao-ku" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "WenWuCaiShenBaoKu",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/WenWuCaiShenBaoKu.vue